import PhotoModalCloseButton from '../src/PhotoModalCloseButton';
export default PhotoModalCloseButton;
